import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { TabsLayout } from '@/layouts/TabsLayout'
import type { TabNavigationItem } from '@/components/Tabs/TabsNavigation'

const TAB_VISAO_GERAL: TabNavigationItem = {
  value: 'visao-geral',
  label: 'Visão Geral',
  icon: 'mdi:view-dashboard-outline',
  to: '/afiliados',
}

const TAB_LISTA: TabNavigationItem = {
  value: 'lista',
  label: 'Lista',
  icon: 'mdi:account-group-outline',
  to: '/afiliados/lista',
}

const TAB_SALDO: TabNavigationItem = {
  value: 'saldo',
  label: 'Saldo manual',
  icon: 'mdi:wallet-outline',
  to: '/afiliados/saldo',
}

const TAB_RELATORIO: TabNavigationItem = {
  value: 'relatorio',
  label: 'Relatório',
  icon: 'mdi:file-chart-outline',
  to: '/afiliados/relatorio',
}

function isAfiliadosSaldoPath(pathname: string): boolean {
  return pathname === '/afiliados/saldo' || pathname.startsWith('/afiliados/saldo/')
}

/**
 * Abas de Afiliados: "Saldo manual" só aparece em /afiliados/saldo (acesso pelos links internos, ex. lista).
 */
export function AfiliadosTabsLayout() {
  const { pathname } = useLocation()

  const tabs = useMemo(() => {
    const showSaldoTab = isAfiliadosSaldoPath(pathname)
    if (showSaldoTab) {
      return [TAB_VISAO_GERAL, TAB_LISTA, TAB_SALDO, TAB_RELATORIO]
    }
    return [TAB_VISAO_GERAL, TAB_LISTA, TAB_RELATORIO]
  }, [pathname])

  return (
    <TabsLayout
      title="Afiliados"
      subtitle="Gerencie seu programa de afiliados e comissões"
      tabs={tabs}
    />
  )
}
